// extracted by mini-css-extract-plugin
export default {"container":"Header-module__container--EQoku"};